import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop({ containerElem = window }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (containerElem) {
      // eslint-disable-next-line no-param-reassign
      containerElem.scrollTop = 0;
    }
  }, [pathname, containerElem]);

  return null;
}
